import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document
	.querySelectorAll('.js-afisha-scroll')
	.forEach(container => {
		new Swiper(container.querySelector('.swiper'), {
			spaceBetween: 10,
            slidesPerView: 'auto',
            breakpoints: {
				600: {
					slidesPerView: 'auto',
					spaceBetween: 11
				},
				1601: {
                    slidesPerView: 'auto',
					spaceBetween: 16
				}
            }
		});
	});
